var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7854 0.429199C28.614 0.429199 0 29.0432 0 64.2146C0 99.386 28.614 128 63.7854 128C98.9568 128 127.571 99.386 127.571 64.2146C127.571 29.0432 98.9568 0.429199 63.7854 0.429199ZM63.7854 121.415C32.2442 121.415 6.58481 95.7558 6.58481 64.2146C6.58481 32.6734 32.2442 7.01401 63.7854 7.01401C95.3266 7.01401 120.986 32.6734 120.986 64.2146C120.986 95.7558 95.3266 121.415 63.7854 121.415Z",
    fill: "url(#paint0_linear_759_867)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4542 35.5785C90.1485 35.2727 89.7855 35.0302 89.386 34.8647C88.9866 34.6992 88.5584 34.614 88.126 34.614C87.6936 34.614 87.2654 34.6992 86.866 34.8647C86.4665 35.0302 86.1035 35.2727 85.7978 35.5785L54.918 66.4586L43.0535 54.6089C42.4361 53.9919 41.5989 53.6453 40.7261 53.6453C39.8532 53.6453 39.0161 53.9919 38.3987 54.6089L28.7039 64.3064C28.0864 64.9238 27.7396 65.7612 27.7396 66.6344C27.7396 67.5076 28.0864 68.345 28.7039 68.9625L52.5922 92.8508C52.898 93.1566 53.2609 93.3992 53.6604 93.5647C54.0599 93.7301 54.4881 93.8153 54.9205 93.8153C55.3528 93.8153 55.781 93.7301 56.1805 93.5647C56.58 93.3992 56.9429 93.1566 57.2487 92.8508L100.149 49.9301C100.766 49.3127 101.113 48.4754 101.113 47.6023C101.113 46.7293 100.766 45.892 100.149 45.2746L90.4542 35.5785ZM54.919 85.866L35.687 66.6344L40.728 61.5931L52.5929 73.4428C53.2103 74.0597 54.0473 74.4063 54.9201 74.4063C55.7929 74.4063 56.63 74.0597 57.2474 73.4428L88.1258 42.5643L93.1662 47.6046L54.919 85.866Z",
    fill: "url(#paint1_linear_759_867)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_759_867",
    x1: 63.7854,
    y1: -11.5107,
    x2: 63.7854,
    y2: 136.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_759_867",
    x1: 64.4264,
    y1: -11.5108,
    x2: 64.4264,
    y2: 136.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8faa3dbd075193812a0dddc0274649f3.svg";
export { ForwardRef as ReactComponent };